<template>
  <v-dialog :value="open" max-width="415px">
    <v-card>
      <v-card-title>
        この度は{{ isSide ? '決定おめでとうございます' : '内定おめでとうございます。'}}<br>
        Nishika担当者からご連絡させていただきますので、今しばらくお待ちください。
      </v-card-title>
      <v-card-actions class="pt-0">
        <v-spacer/>
        <v-btn
            @click="onClose"
            class="mr-4 mb-2"
            color="primary"
        >閉じる</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "JoinCompleteDialog",
  props: {
    open: {
      type: Boolean
    },
    isSide: {
      type: Boolean,
    }
  },
  methods: {
    onClose() {
      this.$emit("close")
    }
  }
}
</script>

<style scoped>

</style>